import { ScrollView } from 'react-native';
import { Flex, RemoteImage, Typography } from '@banhala/ui-kit';

const MULTI_IMAGE_SIZE = 140;
const SINGLE_IMAGE_SIZE = 40;

export const InlineProductHeader = ({
  goodsName,
  imageUrls,
  onPressImage,
}: {
  goodsName: string;
  imageUrls: string[];
  onPressImage: (index: number) => void;
}) => {
  if (imageUrls.length >= 2) {
    return (
      <ScrollView
        horizontal={true}
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{
          paddingHorizontal: 12,
          paddingTop: 12,
          gap: 2,
        }}
      >
        {imageUrls.map((url, index) => (
          <Flex key={`${index}-${url}`} onPress={() => onPressImage(index)}>
            <RemoteImage
              uri={url}
              width={MULTI_IMAGE_SIZE}
              height={MULTI_IMAGE_SIZE}
            />
          </Flex>
        ))}
      </ScrollView>
    );
  }

  const singleUrl = imageUrls[0];
  const singleImage = singleUrl ? (
    <Flex onPress={() => onPressImage(0)}>
      <RemoteImage
        uri={singleUrl}
        width={SINGLE_IMAGE_SIZE}
        height={SINGLE_IMAGE_SIZE}
      />
    </Flex>
  ) : (
    <Flex
      width={SINGLE_IMAGE_SIZE}
      height={SINGLE_IMAGE_SIZE}
      backgroundColor={'bg_secondary'}
    />
  );

  return (
    <Flex padding={{ bottom: 16 }}>
      <Flex.Row
        padding={{ horizontal: 12, vertical: 12 }}
        alignItems={'center'}
        gap={8}
      >
        {singleImage}
        <Flex flex={1}>
          <Typography
            type={'body4'}
            color={'content_secondary'}
            numberOfLines={2}
          >
            {goodsName}
          </Typography>
        </Flex>
      </Flex.Row>
      <Flex height={1} backgroundColor={'bg_tertiary'} />
    </Flex>
  );
};
